module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"route":{"indoor":"内部","outdoor":"外部"},"button":{"close":"閉じる"}},"en":{"route":{"indoor":"Indoor","outdoor":"Outdoor"},"button":{"close":"Close"}}}')
  delete Component.options._Ctor
}
